import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/sunglasses'
import { ClickAndReserveContainer } from '@grandvisionhq/www-next/slot-components/ClickAndReserveContainer'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { sunglassesSpecifications } from '../../../configuration'

const slots: Props['slots'] = {
  AfterCTA: ClickAndReserveContainer,
}

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  return <Page {...props} slots={slots} specificationConfiguration={sunglassesSpecifications} />
}

ProductDetailPage.getInitialProps = Page.getInitialProps

export default composePDP<Props>(ProductDetailPage)
